import { Container, Form, Spinner, Row, Col } from "reactstrap";
import React, { useState } from 'react';
import { ToastMessage } from '../../components/ToastMessage/ToastMessage';
import { errorToast } from '../../constants/toast';
import { setUpUser } from '../../utilities/orgPanelApiCalls';
import DeviceSubscription from "../../components/DeviceSubscription/DeviceSubscription"
import StyledButton from "../../components/Buttons/StyledButton";
import { InitialAccountDataStorageKey, StaffPermissionsLevel } from '../../constants/localStorage';

const PurchaseSubscriptionsPage = ({ prevPage }) => {
    const [isLoading, setIsLoading] = useState();
    const [toast, SetToast] = useState();
    const [numberOfDevices, setNumberOfDevices] = useState(0);
    
    const makeToast = (message, type) => {
        SetToast({
            display: true,
            message: message,
            type: type
        });
    }

    const toastToggleCallback = () => {
        SetToast({
            display: false,
            message: ""
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        
        async function submit() {
            setIsLoading(true);
            const initialAccountData = JSON.parse(localStorage.getItem(InitialAccountDataStorageKey));
            const chooseYourBucketsData = JSON.parse(localStorage.getItem(StaffPermissionsLevel));
            initialAccountData.permissionLevel = chooseYourBucketsData.permissionSelected;
            initialAccountData.seatCount = numberOfDevices;
            initialAccountData.isDcgAutomation = false;
            var result = await setUpUser(initialAccountData);
            if (result.status > 299) {
                makeToast(`Failed to updated subscription - ${result.data.substring(0, 100)}`, errorToast);
                setIsLoading(false);
            }
            if (result.status <= 299) {
                window.location.href = result.data;
            }
        } submit();
    }

    return (
        <>
            {toast?.display && (
                <ToastMessage Message={toast?.message} ToggleCallback={toastToggleCallback} Type={toast?.type} />
            )}
            <h2 className="m-4 text-center">Purchase Device Licenses</h2>
            {!isLoading &&
                <>
                <h3 className="mt-4 text-center">Each device requires a license to get started! How many devices will you have?</h3>
                <p className="text-center">(You can add more licenses later as you grow!)</p>
                    <hr className="w-50"></hr>
                    <Container className="mt-6">
                        <Form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
                        <DeviceSubscription submitHandler={handleSubmit} value={numberOfDevices} setValue={setNumberOfDevices} />
                            <Row className="justify-content-center mt-5">
                                <Col className="onboarding-nav-btn d-flex justify-content-end h-100 pr-5">
                                    <StyledButton onClick={prevPage} width="120px" height = "27px" text="Back" />
                                </Col>
                                <Col className="onboarding-nav-btn buttom-btn d-flex justify-content-start h-100 pr-3">
                                    <StyledButton  width="120px" height = "27px" type="submit" text="Get Started!" /> 
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </>
            }
            {isLoading && <Spinner className="centered-onboarding-loader" /> }
        </>
    );
};

export default PurchaseSubscriptionsPage;
